import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
//import { AgmCoreModule, GoogleMapsAPIWrapper } from '@agm/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PreloaderComponent } from './components/layouts/preloader/preloader.component';
import { HomeOneComponent } from './components/pages/home-one/home-one.component';
import { HomeTwoComponent } from './components/pages/home-two/home-two.component';
import { HomeThreeComponent } from './components/pages/home-three/home-three.component';
import { HomeFourComponent } from './components/pages/home-four/home-four.component';
import { HomeFiveComponent } from './components/pages/home-five/home-five.component';
import { HomeSixComponent } from './components/pages/home-six/home-six.component';
import { HomeSevenComponent } from './components/pages/home-seven/home-seven.component';
import { HomeEightComponent } from './components/pages/home-eight/home-eight.component';
import { HomeNineComponent } from './components/pages/home-nine/home-nine.component';
import { HomeTenComponent } from './components/pages/home-ten/home-ten.component';
import { HomeElevenComponent } from './components/pages/home-eleven/home-eleven.component';
import { HomeTwelveComponent } from './components/pages/home-twelve/home-twelve.component';
import { HomeThirteenComponent } from './components/pages/home-thirteen/home-thirteen.component';
import { HomeFourteenComponent } from './components/pages/home-fourteen/home-fourteen.component';
import { HomeFifteenComponent } from './components/pages/home-fifteen/home-fifteen.component';
import { HomeSixteenComponent } from './components/pages/home-sixteen/home-sixteen.component';
import { HomeSeventeenComponent } from './components/pages/home-seventeen/home-seventeen.component';
import { HomeEighteenComponent } from './components/pages/home-eighteen/home-eighteen.component';
import { HomeNineteenComponent } from './components/pages/home-nineteen/home-nineteen.component';
import { HomeTwentyComponent } from './components/pages/home-twenty/home-twenty.component';
import { HomeTwentyOneComponent } from './components/pages/home-twenty-one/home-twenty-one.component';
import { HomeTwentyTwoComponent } from './components/pages/home-twenty-two/home-twenty-two.component';
import { HomeTwentyThreeComponent } from './components/pages/home-twenty-three/home-twenty-three.component';
import { HomeTwentyFourComponent } from './components/pages/home-twenty-four/home-twenty-four.component';
import { HomeTwentyFiveComponent } from './components/pages/home-twenty-five/home-twenty-five.component';
import { HomeTwentySixComponent } from './components/pages/home-twenty-six/home-twenty-six.component';
import { HomeTwentySevenComponent } from './components/pages/home-twenty-seven/home-twenty-seven.component';
import { HomeTwentyEightComponent } from './components/pages/home-twenty-eight/home-twenty-eight.component';
import { HomeTwentyNineComponent } from './components/pages/home-twenty-nine/home-twenty-nine.component';
import { HomeThirtyComponent } from './components/pages/home-thirty/home-thirty.component';
import { HomeFortyComponent } from './components/pages/home-forty/home-forty.component';
import { HomeThirtyOneComponent } from './components/pages/home-thirty-one/home-thirty-one.component';
import { HomeThirtyTwoComponent } from './components/pages/home-thirty-two/home-thirty-two.component';
import { HomeThirtyThreeComponent } from './components/pages/home-thirty-three/home-thirty-three.component';
import { HomeThirtyFourComponent } from './components/pages/home-thirty-four/home-thirty-four.component';
import { HomeThirtyFiveComponent } from './components/pages/home-thirty-five/home-thirty-five.component';
import { HomeThirtySixComponent } from './components/pages/home-thirty-six/home-thirty-six.component';
import { HomeThirtySevenComponent } from './components/pages/home-thirty-seven/home-thirty-seven.component';
import { HomeThirtyEightComponent } from './components/pages/home-thirty-eight/home-thirty-eight.component';
import { HomeThirtyNineComponent } from './components/pages/home-thirty-nine/home-thirty-nine.component';
import { BlogDetailsComponent } from './components/pages/blog-details/blog-details.component';
import { WorksDetailsComponent } from './components/pages/works-details/works-details.component';
import { ServicesDetailsComponent } from './components/pages/services-details/services-details.component';
import { DemoSidebarComponent } from './components/layouts/demo-sidebar/demo-sidebar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgcCookieConsentModule, NgcCookieConsentConfig} from 'ngx-cookieconsent';
import {NgxGoogleAnalyticsModule,NgxGoogleAnalyticsRouterModule  } from 'ngx-google-analytics';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { CookieService } from 'ngx-cookie-service';
import { MessageDialogComponent } from './message-dialog/message-dialog.component';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogModule, MatDialogTitle, MatDialog} from '@angular/material/dialog';
import {Dialog, DIALOG_DATA, DialogModule} from '@angular/cdk/dialog';
import { MapComponent } from './map/map.component';
import { DialogComponentComponent } from './dialog-component/dialog-component.component';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BannerComponent } from './components/banner/banner.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { WelcomePopupComponent } from './welcome-popup/welcome-popup.component';


const cookieConfig:NgcCookieConsentConfig = {
    "cookie": {
      "domain": "localhost:4200"
    },
    "position": "bottom",
    "theme": "classic",
    "palette": {
      "popup": {
        "background": "#000000",
        "text": "#ffffff",
        "link": "#ffffff"
      },
      "button": {
        "background": "#f1d600",
        "text": "#000000",
        "border": "transparent"
      }
    },
    "type": "opt-out",
    "content": {
      "message": "Questo sito utilizza solo cookie analitici (senza alcuna profilazione degli utenti). Per saperne di più, leggi l’informativa.",
      "dismiss": "Got it!",
      "deny": "Nega cookies",
      "link": "Learn more",
      "href": "/privacy-policy",
      "policy": "Cookie Policy",
      "allow": "Accetta cookies"
    }
};



@NgModule({
  declarations: [
    AppComponent,
    PreloaderComponent,
    HomeOneComponent,
    HomeTwoComponent,
    HomeThreeComponent,
    HomeFourComponent,
    HomeFiveComponent,
    HomeSixComponent,
    HomeSevenComponent,
    HomeEightComponent,
    HomeNineComponent,
    HomeTenComponent,
    HomeElevenComponent,
    HomeTwelveComponent,
    HomeThirteenComponent,
    HomeFourteenComponent,
    HomeFifteenComponent,
    HomeSixteenComponent,
    HomeSeventeenComponent,
    HomeEighteenComponent,
    HomeNineteenComponent,
    HomeTwentyComponent,
    HomeTwentyOneComponent,
    HomeTwentyTwoComponent,
    HomeTwentyThreeComponent,
    HomeTwentyFourComponent,
    HomeTwentyFiveComponent,
    HomeTwentySixComponent,
    HomeTwentySevenComponent,
    HomeTwentyEightComponent,
    HomeTwentyNineComponent,
    HomeThirtyComponent,
    HomeFortyComponent,
    HomeThirtyOneComponent,
    HomeThirtyTwoComponent,
    HomeThirtyThreeComponent,
    HomeThirtyFourComponent,
    HomeThirtyFiveComponent,
    HomeThirtySixComponent,
    HomeThirtySevenComponent,
    HomeThirtyEightComponent,
    HomeThirtyNineComponent,
    BlogDetailsComponent,
    WorksDetailsComponent,
    ServicesDetailsComponent,
    DemoSidebarComponent,
    MessageDialogComponent,
    MapComponent,
    BannerComponent,
    PrivacyPolicyComponent,
    WelcomePopupComponent  
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    DialogModule,
   NgcCookieConsentModule.forRoot(cookieConfig),
  //  NgcCookieConsentModule.forRoot({
  //   cookie: {
  //     domain: 'localhost', // Replace with your domain name
  //   },
  //  }),
    HttpClientModule,
    //NgxGoogleAnalyticsModule.forRoot('G-3YZ1PCMZEE'),
    //NgxGoogleAnalyticsModule.forRoot(),
    NgxGoogleAnalyticsRouterModule.forRoot(),
    // AgmCoreModule.forRoot({
    //   apiKey: 'AIzaSyB4q0ZurDnTN2efrr_gLMnCYci40TNTLQY',
    //   apiVersion: '3.31'
    // })
  ],
  //providers: [GoogleMapsAPIWrapper],
  providers: [
    provideAnimations()
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
